import { Star } from "lucide-react";
import { useLocation } from "react-router";
import { useFavorites } from "@/shared/contexts/FavoritesContext";
import { cn } from "@/shared/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/Tooltip";

const FavoriteStar = () => {
  const { pathname } = useLocation();
  const { isFavorite, toggleFavorite, isFull } = useFavorites();

  const active = isFavorite(pathname);
  const blocked = !active && isFull;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => toggleFavorite(pathname)}
          className={cn(
            "shrink-0 cursor-pointer transition-colors",
            active
              ? "text-blue-500"
              : "text-muted-foreground hover:text-blue-500",
            blocked && "opacity-50 cursor-not-allowed",
          )}
          aria-label={active ? "Retirer des favoris" : "Ajouter aux favoris"}
        >
          <Star
            className={cn("", active && "fill-blue-500")}
            size={22}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        {blocked
          ? "Maximum de 5 favoris atteint"
          : active
            ? "Retirer des favoris"
            : "Ajouter aux favoris"}
      </TooltipContent>
    </Tooltip>
  );
};

export default FavoriteStar;
